<script>
import InvoicesApi from "@/services/invoices-api";
import Swal from "sweetalert2";
import templateZERO from "@/components/AddNewAvoirModal";
import templateONE from "@/components/AddNewAvoirModal1";
import templateZERONewUi from "@/components/AddNewAvoirModalNewUi";
import templateONENewUi from "@/components/AddNewAvoirModal1NewUi";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.length === 2 ? parts.pop().split(';').shift() : null;
}

// Payment natures as the ERP writes them (FACT_NATURE_REG, e.g. "CHÈQUE SIMPLE", "VIREMENT OMNIPHARM")
const REGLEMENT_KINDS = {
  cheque: { label: "Chèque", icon: "bx-note" },
  guarantee: { label: "Chèque de garantie", icon: "bx-note" },
  traite: { label: "Traite", icon: "bx-calendar-event" },
  transfer: { label: "Virement", icon: "bx-transfer" },
  cash: { label: "Espèces", icon: "bx-money" },
  withholding: { label: "Retenue à la source", icon: "bx-file" },
  adjustment: { label: "Écart de règlement", icon: "bx-adjust" },
  other: { label: null, icon: "bx-wallet" },
};

export default {
  components: {templateZERO ,templateONE},
      props: {
        status: Number,
        customerId:Number,
        start:{
          type:String,
          default:null
        },
        agencySelected:{
          type:String,
          default:null
        },
        end:{
          type:String,
          default:null
        },
        type:{
          type:String,
          default:null
        },
        withHoldingColumn:{
          type:Boolean,
          default: false
        },
        isBlList:{
          type:Boolean,
          default: false
        },

        isInvoiceList:{
          type:Boolean,
          default: false
        },

        isAvoirList:{
          type:Boolean,
          default: false
        },
        isConsigneList:{
          type:Boolean,
          default: false
        },
        withClaim:{
          type:Boolean,
          default: false
        },
        api:{
          type:Function,
          default: null
        },
        displayAccusedModal:{
          type:Boolean,
          default: false
        },
        isAvoirDetailsButton:{
          type:Boolean,
          default: false
        },
      },

    mounted(){
      if((!this.isAvoirList && !this.isBlList && this.role == 1) || this.role != 1  ){
        this.getInvoices();
      }
    },
    created() {
      this.invoiceTypes = [
        { label: this.invoiceLabelWithoutSignature, code: 0 },
        { label: process.env.VUE_APP_CLIENT_NAME === "cab" ? this.$t("reporting.supplier.tabMailInvoice.btnElectronicCab") : this.$t("reporting.supplier.tabMailInvoice.btnElectronic"), code: 1 }
      ];

      if (this.isTtnInvoiceEnable) {
        this.invoiceTypes.push({ label: "Facture électronique TTN", code: 2 });
      }
    },

    computed: {
        isHideRestraintColumnInInvoicesEnabled(){
          return  process.env.VUE_APP_FEATURE_HIDE_RESTRAINT_COLUMN_IN_INVOICES === 'true'
        },
        isShowRelatedBL_BR_Enabled(){
          return  process.env.VUE_APP_FEATURE_SHOW_RELATED_BR_BL_BUTTON === 'true'
        },
        isReglementRelatedToInvoiceEnabled(){
          return process.env.VUE_APP_FEATURE_REGLEMENT_RELATED_TO_INVOICE === 'true'
        },
        reglementSummary() {
          const invoice = this.selectedInvoice || {};
          const total = this.parseReglementAmount(invoice.totalWithTaxes);
          let remaining = this.parseReglementAmount(invoice.soldeAmount);
          // the ERP returns -0 for settled invoices and a few cents below 0 for overpaid ones
          if (remaining !== null && remaining < 0.0005) remaining = Math.max(remaining, 0);
          const state = invoice.isPaidInvoice || remaining === 0 ? "paid" : (remaining !== null ? "due" : null);
          const percent = total > 0 && remaining !== null ? Math.min(100, Math.max(0, ((total - remaining) / total) * 100)) : null;
          return {
            state,
            total: total !== null ? this.formatReglementAmount(total) : "-",
            paid: total !== null && remaining !== null ? this.formatReglementAmount(Math.max(total - remaining, 0)) : null,
            remaining: remaining !== null ? this.formatReglementAmount(remaining) : null,
            percent,
            percentLabel: percent === null ? "" : (Number.isInteger(Math.round(percent * 10) / 10) ? Math.round(percent) : (Math.floor(percent * 10) / 10).toFixed(1).replace(".", ",")) + " %",
          };
        },
        reglementRows() {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return (this.reglementList || [])
            .map((reglement, position) => {
              const kind = this.reglementKind(reglement.paymentType);
              const date = this.parseReglementDate(reglement.paymentDate);
              const dueDate = this.parseReglementDate(reglement.paymentDueDate);
              let due = null;
              // only cheques and traites carry a real due date; the ERP copies the payment date on the others
              if (dueDate && ["cheque", "guarantee", "traite"].includes(kind) && (!date || dueDate.getTime() !== date.getTime())) {
                const days = Math.round((dueDate.getTime() - today.getTime()) / 86400000);
                due = days > 0
                  ? { state: "upcoming", label: "Échéance le " + reglement.paymentDueDate + " · dans " + days + (days > 1 ? " jours" : " jour") }
                  : days === 0
                    ? { state: "upcoming", label: "Échéance aujourd'hui" }
                    : { state: "past", label: "Échéance du " + reglement.paymentDueDate };
              }
              return {
                kind,
                position,
                time: date ? date.getTime() : 0,
                label: this.reglementLabel(kind, reglement.paymentType),
                icon: REGLEMENT_KINDS[kind].icon,
                rawType: reglement.paymentType || "",
                meta: [reglement.paymentDate, reglement.paymentReference ? "N° " + reglement.paymentReference : null].filter(Boolean).join(" · "),
                due,
                amount: reglement.paymentAmount || "-",
                // paymentAmount (FACT_MNT_REG) is the share allocated to this invoice, mntReg (MNT_REG) the whole payment; both are formatted strings
                mntReg: this.parseReglementAmount(reglement.mntReg) - this.parseReglementAmount(reglement.paymentAmount) > 0.0005 ? reglement.mntReg : null,
              };
            })
            .sort((a, b) => a.time - b.time || a.position - b.position);
        },
        isInvoicePaymentStatusEnabled(){
          return process.env.VUE_APP_FEATURE_INVOICE_PAYMENT_STATUS === 'true'
        },
        // Omnipharm: new look of the invoices list buttons and acknowledgement column
        isInvoicesListNewUxEnabled(){
          return process.env.VUE_APP_FEATURE_INVOICES_LIST_NEW_UX === 'true'
        },
        role() {
          return this.$cookies.get('userr');
        },

        permission() {
          const storedPermissions = getCookie('permission');
          return storedPermissions ? JSON.parse(storedPermissions) : [];
        },

        canViewInvoicePayment() {
          return this.role == 1 || (this.role == 0 && this.permission.includes('CUSTOMER_ADMIN'));
        },

        isAdmin() {
          return this.$cookies.get('userr') == 1;
        },

        tableFieldsForCustomer() {
          return this.tableFields.filter(f => f.key !== "customer" && (this.withHoldingColumn || f.key !="withHolding" ) && (this.displayAccusedModal || f.key !="askDetails" )  && (this.withClaim || f.key !="claim" ) && ((this.isInvoiceList && this.isInvoicePaymentStatusEnabled && this.canViewInvoicePayment) || f.key !== "paymentStatus") && (this.isInvoiceList &&  (this.isReglementRelatedToInvoiceEnabled && (this.permission.includes('CUSTOMER_ADMIN') || this.permission.includes('SUPPLIER_ADMIN'))) || (f.key !== "paymentDetails" && f.key !== "remainingDaysToPay")) );
        },

        tableFieldsForSupplier() {
           return this.tableFields.filter(f => (this.withHoldingColumn || f.key !="withHolding" )  && (this.displayAccusedModal || f.key !="askDetails" ) && ((this.isInvoiceList && this.isInvoicePaymentStatusEnabled && this.canViewInvoicePayment) || f.key !== "paymentStatus") && (this.isInvoiceList && (this.isReglementRelatedToInvoiceEnabled && (this.permission.includes('CUSTOMER_ADMIN') || this.permission.includes('SUPPLIER_ADMIN')) ) || (f.key !== "paymentDetails" && f.key !== "remainingDaysToPay")));
        },
        tableAvoirRequestFieldsForCustomer() {
          return this.AvoirRequestTableFields.filter(f => f.key !== "customer"  );
        },
        templateAddNewAvoirModalNumber(){
          return parseInt(process.env.VUE_APP_FEATURE_TEMPLATE_ADD_NEW_AVOIR, 10)
        },

        // redesigned demande d'avoir modal; instances without the flag keep the original one
        isAvoirRequestNewUiEnabled(){
          return process.env.VUE_APP_FEATURE_AVOIR_REQUEST_NEW_UI === 'true'
        },

        avoirModalZero(){
          return this.isAvoirRequestNewUiEnabled ? templateZERONewUi : templateZERO
        },

        avoirModalOne(){
          return this.isAvoirRequestNewUiEnabled ? templateONENewUi : templateONE
        },

        envSupplierName(){
          return process.env.VUE_APP_CLIENT_NAME
        },

        isElectronicInvoiceEnable() {
          return process.env.VUE_APP_FEATURE_ELECTRONIC_INVOCE === "true";
        },

        isTtnInvoiceEnable() {
          return process.env.VUE_APP_FEATURE_ENABLE_TTN_INVOCE === "true";
        },

        isInvoicePerItemEnable() {
          return process.env.VUE_APP_FEATURE_ENABLE_INVOCE_PER_ITEM === "true";
        },

        invoiceLabelWithoutSignature(){
          return "Relevé " + process.env.VUE_APP_CLIENT_FULL_NAME
        },

        isHideTtnPara() {
          return process.env.VUE_APP_FEATURE_HIDE_TTN_PARA === "true";
        },

        isParaOnly(){
          return  process.env.VUE_APP_FEATURE_PARA_ONLY === 'true'
        },

        isParaTtnEnable(){
          return  process.env.VUE_APP_FEATURE_ELECTRONIC_PARA_INVOCE === 'true'
        },

        isSearchAvoirItemWithBarcodeScannerEnabled(){
          return  process.env.VUE_APP_FEATURE_SEARCH_AVOIR_ITEM_WITH_BARCODE_SCANNER === 'true'
        },

    },
    data (){
        return {
            //role:null,
            invoicesList:[],
            slicedInvoicesList:[],
            pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
            isTableLoading:false,
            tableFields: [
              { key:"number", label: "Numéro", thClass:"align-middle", tdClass:"font-weight-bold  align-middle "},
              
              { key:"customer", label: "Client", thClass:"align-middle", tdClass:"font-weight-bold align-middle"},
              { key:"company", label: "", thClass:"align-middle", tdClass:"font-weight-bold align-middle"},

              { key:"date", label: "Date",thClass:"align-middle", tdClass:"align-middle" },
              
              { key:"totalWithTaxes", label: "Total TTC (TND)",thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              { key:"paymentStatus", label: "Reste à payer", thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              { key:"paymentDetails", label: "", thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              { key:"remainingDaysToPay", label: "Échéance", thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              { key:"withHolding", label: "",thClass:"align-middle text-right", tdClass:"align-middle text-right"},

              { key:"askDetails", label: "Accusé de réception",thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              { key:"claim", label: "",  thClass:"text-center ", tdClass:"align-middle text-center"},

              { key:"actions", label:"",tdClass:"d-flex justify-content-end"},
              ],

              AvoirRequestTableFields: [

              { key:"avoirId", label: "Numéro", thClass:"align-middle", tdClass:"font-weight-bold  align-middle "},
              
              { key:"date", label: "Date",thClass:"align-middle", tdClass:"align-middle" },
              
              { key:"customer", label: "Client", thClass:"align-middle", tdClass:"font-weight-bold align-middle"},
              
              { key:"status", label: "Etats",thClass:"align-middle text-left ", tdClass:"align-middle text-left "},
             
              { key:"avoirLinesCount", label: "Articles",thClass:"align-middle text-center", tdClass:"align-middle text-center"},

              { key:"actions", label:"",tdClass:"d-flex justify-content-end"},
              ],
              consigneTableFields: [
                { key: "articleCode", label: "Code article", thClass: "align-middle", tdClass: "font-weight-bold align-middle" },
                { key: "articleDescription", label: "Désignation", thClass: "align-middle", tdClass: "align-middle" },
                { key: "quantity", label: "Quantité", thClass: "align-middle text-right", tdClass: "align-middle text-right" },
                { key: "message", label: "Message", thClass: "align-middle", tdClass: "align-middle" },
              ],
              exportInvoicesInProgress : false,
              isDownloadInProgress: false,
              showAddNewAvoirModal: false ,
              avoirDetails: {},
              isNew: false ,
              consigneList: [],
              BLList:[],
              BRList:[],
              selectedInvoice:null,
              showBLandBRModal: false ,
              isTableRelatedBLLoading:false,
              isTableRelatedBRLoading:false,
              pagemodelBLList: {currentPage : 1, perPage : 10, totalRows: 0},
              pagemodelBRList: {currentPage : 1, perPage : 10, totalRows: 0},
              relatedBLTableFields: [
                { key:"number", label: "Numéro", thClass:"align-middle", tdClass:"font-weight-bold  align-middle "},
                { key:"date", label: "Date",thClass:"align-middle", tdClass:"align-middle" },
                { key:"totalWithTaxes", label: "Total TTC (TND)",thClass:"align-middle text-left ", tdClass:"align-middle text-left "},
                { key:"actions", label:"",tdClass:"text-center align-middle"},
              ],
               activeTabIndex: 0,

              invoiceTypes: [],
              showReglementModal: false,
              isTableRelatedReglementLoading: false,
              pagemodelReglementList: {currentPage : 1, perPage : 50, totalRows: 0},
              reglementList: [],

        }
    },
    methods: {


      downloadInvoice(item, downloadType) {
        this.isAvoirDetailsButton == true ? this.openAvoirDetails(item):this.accusedModal(item.id, item.type , item.number, item.askDate, downloadType)
      },

      addClaim(bl){
       this.$router.push({ path: '/claim', query: {  blNumber: bl.number  } });
    },
        onCloseAddNewAvoirModal(){
          this.getInvoices()
      this.showAddNewAvoirModal= false
      this.isNew = false
    },  
    downloadrelatedBLByDocNumber(blNumber , docType,type){
      this.downloadBLByDocNumber(blNumber,docType,type, this.customerId);
    },
    downloadBLByDocNumber(blNumber , docType,type){
          this.isDownloadInProgress=true;
          InvoicesApi.downloadBLByDocNumber(blNumber , type, docType, this.customerId)
          .finally(() => {
          this.isDownloadInProgress = false;
          this.getInvoices()
          })
      },

    requestAvoirStatusToLabel(status){
      switch(status){
        case 0: return 'Brouillon';
        case 1: return 'Envoyée';
        case 2:return 'Traitée';
        case 3 :return 'Traitée'; // show status REFUSE same as VALIDATE
        default: return '_'
      }
    },

    requestAvoirToColor(status){
    
      switch(status){
        case 0: return 'secondary';
        case 1: return 'warning';
        case 2:return 'success';
        case 3 :return 'success'; // show status REFUSE same as VALIDATE
        default: return '_'
      }
    },

    getInvoices() {
      this.isTableLoading = true;

      if(this.role == 1 &&this.isConsigneList && this.customerId == null){
        this.consigneList = [];
        this.isTableLoading = false;
        return;
      }

      //InvoicesApi.getInvoices
      this.api(this.pagemodel.currentPage, this.pagemodel.perPage,this.customerId,this.status,this.start,this.end, this.type, this.agencySelected)
        .then(result => {
          if(result ) {
            if (this.isConsigneList) {
              this.consigneList = result || [];
              this.invoicesList = [];
            } else {
              this.invoicesList = result.list || [];
              this.consigneList = [];
            }
            
            this.pagemodel.totalRows = result.total;
            this.pagemodel.currentPage = result.page;
            this.pagemodel.perPage = result.pageSize;
            this.pagemodel.pageSize = result.pageSize;

            if (!this.isConsigneList) {
              this.slicedInvoicesList = this.getSlicedInvoices();
            }
          }
          
        })
        .finally(() => {
        this.isTableLoading = false;
      })
    },

    getSlicedInvoices() {
      this.isTableLoading = true;
      this.pagemodel.pageSize = this.pagemodel.perPage;
      this.slicedInvoicesList = this.invoicesList.slice(this.pagemodel.currentPage ? (this.pagemodel.currentPage - 1) * this.pagemodel.perPage : 0, 
                                                       this.pagemodel.pageSize ? this.pagemodel.currentPage * this.pagemodel.perPage : 10)
      this.isTableLoading = false;
      return this.slicedInvoicesList ;
    },

    showAvoirModal(){
      this.avoirDetails = {}
      this.showAddNewAvoirModal= true
      this.batchDate="";
      this.batchNumber="";
      this.isNew = true
    },

    openAvoirDetails(item){
      this.avoirDetails = item ,
      this.showAddNewAvoirModal= true,
      this.isNew =  item.status != 2 && this.role == 0 && this.templateAddNewAvoirModalNumber == 1;
    },

    ackParts(askDate) {
      // "12/08/2026 10:32" -> { date: "12/08/2026", time: "10:32" }
      const [date, time] = String(askDate || "").trim().split(/\s+/);
      return { date, time };
    },
    dueInfo(invoice, days) {
      if (invoice.isPaidInvoice || days === null || days === undefined || days === "") return null;
      // no ERP balance on this invoice (older invoices synced before the balance existed): nothing is known to be due
      if (invoice.soldeAmount === null || invoice.soldeAmount === undefined || String(invoice.soldeAmount).trim() === "") return null;
      const count = Math.abs(Number(days));
      const unit = count > 1 ? " jours" : " jour";
      if (days < 0) return { state: "overdue", icon: "bx-error-circle", label: "En retard de " + count + unit };
      // the server truncates to whole days: 0 means the due date is today or tomorrow
      if (days == 0) return { state: "soon", icon: "bx-time-five", label: "À échéance" };
      if (days <= 7) return { state: "soon", icon: "bx-time-five", label: "Dans " + count + unit };
      return { state: "ok", icon: "bx-calendar", label: "Dans " + count + unit };
    },
    parseReglementAmount(value) {
      if (value === null || value === undefined || value === "") return null;
      const amount = parseFloat(String(value).replace(/[^\d,.-]/g, "").replace(",", "."));
      return isNaN(amount) ? null : amount;
    },
    formatReglementAmount(amount) {
      const [units, decimals] = Math.abs(amount).toFixed(3).split(".");
      const sign = amount < 0 && Number(units + "." + decimals) !== 0 ? "-" : "";
      return sign + units.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + "," + decimals + " TND";
    },
    parseReglementDate(value) {
      const match = /^(\d{2})\/(\d{2})\/(\d{4})/.exec(value || "");
      return match ? new Date(+match[3], +match[2] - 1, +match[1]) : null;
    },
    reglementKind(type) {
      const nature = String(type || "").toUpperCase().replace(/[ÈÉÊË]/g, "E").trim();
      if (nature.startsWith("RETENUE")) return "withholding";
      if (nature.startsWith("ECART")) return "adjustment";
      if (nature.startsWith("CHEQUE GARANTIE")) return "guarantee";
      if (nature.startsWith("CHEQUE")) return "cheque";
      if (nature.startsWith("TRAITE")) return "traite";
      if (nature.startsWith("VIREMENT")) return "transfer";
      if (nature.startsWith("ESPECE")) return "cash";
      return "other";
    },
    reglementLabel(kind, type) {
      const titleCase = (text) => text.toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());
      const raw = String(type || "").trim();
      if (kind === "other") return raw ? titleCase(raw) : "Règlement";
      // "VIREMENT OMNIPHARM" keeps the account it was paid to
      if (kind === "transfer" && raw.indexOf(" ") > 0) return "Virement " + titleCase(raw.slice(raw.indexOf(" ") + 1));
      return REGLEMENT_KINDS[kind].label;
    },
    openRelatedReglement(invoice){
      if(invoice == null || invoice.id == null ){
        return;
      }
      this.selectedInvoice= invoice
      this.showReglementModal=true;
      this.getRelatedReglement();
    },

    openRelatedBLandBR(invoice){
      if(invoice == null || invoice.id == null ){
        return;
      }
      this.selectedInvoice= invoice
      this.showBLandBRModal=true;
      this.getRelatedBL();
    },
    getRelatedBL(){
      this.isTableRelatedBLLoading=true
      InvoicesApi.getRelatedBL(this.pagemodelBLList.currentPage,this.pagemodelBLList.perPage,this.selectedInvoice.id).then((result)=>{
        this.BLList = result.list
        this.pagemodelBLList.totalRows = result.total;
        this.pagemodelBLList.currentPage = result.page;
        this.pagemodelBLList.perPage = result.pageSize;
        this.pagemodelBLList.pageSize = result.pageSize;
      })
      .finally(()=>{
        this.isTableRelatedBLLoading=false
      })
    },

    getRelatedReglement(){
      this.isTableRelatedReglementLoading=true
      InvoicesApi.getRelatedReglement(this.pagemodelReglementList.currentPage,this.pagemodelReglementList.perPage,this.selectedInvoice.id).then((result)=>{
        this.reglementList = result.list
        this.pagemodelReglementList.totalRows = result.total;
        this.pagemodelReglementList.currentPage = result.page;
        this.pagemodelReglementList.perPage = result.pageSize;
        this.pagemodelReglementList.pageSize = result.pageSize;
      })
      .finally(()=>{
        this.isTableRelatedReglementLoading=false
      })
    },

    getRelatedBR(){
      this.isTableRelatedBRLoading=true
      InvoicesApi.getRelatedBR(this.pagemodelBRList.currentPage,this.pagemodelBRList.perPage,this.selectedInvoice.id).then((result)=>{
        this.BRList = result.list
        this.pagemodelBRList.totalRows = result.total;
        this.pagemodelBRList.currentPage = result.page;
        this.pagemodelBRList.perPage = result.pageSize;
        this.pagemodelBRList.pageSize = result.pageSize;
      })
      .finally(()=>{
        this.isTableRelatedBRLoading=false
      })
    },
    onCloseShowBLandBRModal(){
      this.showBLandBRModal=false;
      this.selectedInvoice=null;
      this.pagemodelBLList  ={currentPage : 1, perPage : 10, totalRows: 0}
      this.pagemodelBRList  ={currentPage : 1, perPage : 10, totalRows: 0}
      this.BLList= [];
      this.BRList= [];
    },
    onCloseShowReglementModal(){
      this.showReglementModal=false;
      this.selectedInvoice=null;
      this.pagemodelReglementList = {currentPage : 1, perPage : 50, totalRows: 0}
      this.reglementList = [];
    },
    accusedModal(blId, type , number, askDate, downloadType){

      if(this.role !=1 && this.displayAccusedModal == true && !askDate){

          Swal.fire({

                   title : "Accusé De Réception",
                    html: "En ouvrant cette facture, <strong>vous accusez la réception de la facture </strong> numéro "+number+" ?",
                         
                    showCancelButton: true,
                    showConfirmButton: true ,
                    allowOutsideClick: true, 
                    confirmButtonColor: "#34c38f",
               
                    customClass: {
                        popup: 'custom-popup-class',
                        title: 'custom-title-class',
                        cancelButton: 'custom-cancel-button-class',
                        confirmButton: 'custom-confirm-button-class',
                    },
                    backdrop: `
                        rgb(38 50 47 / 88%)
                        center left
                        no-repeat
                    `,
                 
                }).then(result => {
                        if (result && result.value) {
                          this.download(blId, type, downloadType)
                        }
                    });

      }else{
        this.isBlList || this.isAvoirList ?
          this.downloadBLByDocNumber(number , this.isBlList ? 1 : 3, this.type ) :
          this.download(blId, type, downloadType);
      }
      
    },


    download(blId, type, downloadType){

      this.isDownloadInProgress=true;
      InvoicesApi.downloadBL(blId, type, downloadType)
      .finally(() => {
        this.isDownloadInProgress = false;
        this.getInvoices()
      })
    },

    statusToColor(status) {
      switch(status) {
        case 0: return 'warning';
        case 1: return 'success';
        case 2: return 'info'
        case 3: return 'danger';
        default: return '';
      }
    },

    statusToLabel(status) {
      switch(status) {
        case 0: return 'unpaid';
        case 1: return 'inprogress';
        case 2: return 'paid';
        default: return '';
      }
    },

    TypeToLabel(status) {
      switch(status) {
        case 0: return 'creditBill';
        case 1: return 'bill';
        default: return '';
      }
    },

    exportInvoicesListExcel: function() {
        return InvoicesApi.export(this.pagemodel.currentPage, this.pagemodel.perPage,this.customerId,this.status,this.start,this.end, this.type)
    },

    getInvoiceTypes(companyName) {

      if (this.isInvoicePerItemEnable && this.isHideTtnPara && companyName === "PARA" ) {
          return this.invoiceTypes.filter(t => t.code != 2);
      }

      if (this.isInvoicePerItemEnable) {
        return this.invoiceTypes;
      }

      if (companyName === "PARA" && !this.isParaTtnEnable) {
        return this.invoiceTypes.filter(t => t.code === 0);
      }

      return this.invoiceTypes;
    },

    },
    watch: {
        status : function(){
          this.getInvoices()
        },
        
        customerId: function(){
          this.getInvoices()
        },
        type: function(){
          this.getInvoices()
        },

        agencySelected: function(){
          this.getInvoices()
        },

        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getInvoices()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getInvoices()

          }
        },
        activeTabIndex(newVal) {
          if (newVal === 1 && this.BRList.length === 0) {
            this.pagemodelBRList  ={currentPage : 1, perPage : 10, totalRows: 0}
            this.getRelatedBR();
          }
        },
    }
};
</script>
<template>
<div>

      <div v-if=" this.envSupplierName == 'omn'" class="mt-5 mb-4"  >
        <a v-if="isInvoiceList" href="/GUIDE-PLATEFORME-TEJ.pdf" target="_blank" rel="noopener">
        <h5 class="text-primary font-weight-bold mt-4">           <i class="fas fa-lightbulb mr-2 text-primary"></i> Plateforme TEJ</h5>
          <span class="text-dark">
            <u>Télécharger</u> le guide d'utilisation de la plateforme.
          </span>
          </a>
      </div>

      <div v-else-if=" this.envSupplierName == 'sop'" class="mt-5 mb-4"  >
        <a v-if="isInvoiceList" href="/EXONERATION-SOPROPHA-2026.pdf" target="_blank" rel="noopener">
        <!--h5 class="text-primary font-weight-bold mt-4">
          <img src="@/assets/images/certified.svg" height="20"  />
          Attestation d'exonération de la retenue à la source</h5-->
          <strong class="text-primary mr-2">Attestation d'exonération de la retenue à la source : </strong>
          <span class="text-dark">
            <u>Télécharger </u>
          </span>
          </a>
      </div>


      <div class="table-responsive mt-3">   
        <b-table 
        :busy="isTableLoading"
        :striped="true"
        :small="false"
        :hover="true"
        :items="isConsigneList ? consigneList : (isBlList || isAvoirList ? slicedInvoicesList : invoicesList)"
        :fields="isConsigneList ? consigneTableFields : ((isAvoirDetailsButton == true && role == 0) ? tableAvoirRequestFieldsForCustomer :(isAvoirDetailsButton == true && role == 1) ?  AvoirRequestTableFields : (role == 0 ? tableFieldsForCustomer : tableFieldsForSupplier))"
        :perPage="pagemodel.perPage"
        class="table  "
        >
        <template v-slot:table-busy>
          <div class="text-center my-2">
              <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </div>
        </template>
        <template v-slot:cell(askDetails)="{item}" v-if="this.displayAccusedModal == true">
          <!-- Omnipharm: who acknowledged on top, when underneath -->
          <div v-if="isInvoicesListNewUxEnabled && item.askDate" class="inv-ack-cell">
            <span v-if="item.askUserName" class="inv-ack__name">{{ item.askUserName }}</span>
            <span class="inv-ack__when">
              <span>{{ ackParts(item.askDate).date }}</span>
              <span v-if="ackParts(item.askDate).time">{{ ackParts(item.askDate).time }}</span>
            </span>
          </div>
          <template v-else-if="!isInvoicesListNewUxEnabled">
          <a v-if="item.askUserName" class="mr-2 text-primary" > {{item.askUserName}} /</a>

          <span v-if="item.askDate" >  {{ item.askDate }}</span>

          </template>
          </template>
          <template v-slot:cell(status)="{item,value}">  
        <h5><b-badge href="#" :variant="requestAvoirToColor(value,item.status)">{{requestAvoirStatusToLabel(value,item.status)}}</b-badge></h5>
      </template>


        <template v-slot:cell(paymentStatus)="{item}">
          <span v-if="item.isPaidInvoice" class="inv-settled"><i class="bx bx-check-circle" aria-hidden="true"></i>Soldée</span>
          <span v-else class="text-danger font-weight-bold">{{ item.soldeAmount }}</span>
        </template>

        <template v-slot:cell(paymentDetails)="{item}">
          <b-button
            class="mr-2 mr-xl-3 text-nowrap"
            title="Voir les règlements de la facture"
            size="sm"
            variant="outline-dark"
            @click="openRelatedReglement(item)"
          >
            <i class="bx bx-receipt font-size-16 align-middle" aria-hidden="true"></i>
            <span class="d-none d-xl-inline font-weight-bold align-middle ml-1">Règlements</span>
          </b-button>
        </template>

        <template v-slot:cell(remainingDaysToPay)="{ item, value }">
          <span v-for="due in [dueInfo(item, value)].filter(Boolean)" :key="due.state" class="inv-due" :class="'inv-due--' + due.state">
            <i class="bx" :class="due.icon" aria-hidden="true"></i>{{ due.label }}
          </span>
        </template>

        <template v-slot:cell(withHolding)="{item}"> 
          <a v-if="item.withHolding && !isHideRestraintColumnInInvoicesEnabled && !isBlList && !isAvoirDetailsButton && !isAvoirList" class="mr-2 text-primary" href="javascript:void(0);" @click="download(item.id, 4) "> Télécharger /</a> <!--i class="fas fa-download"/-->
          <span v-if="item.withHolding && !isHideRestraintColumnInInvoicesEnabled && !isBlList && !isAvoirDetailsButton && !isAvoirList">  {{ item.withHolding }}</span>
        </template>
        <template v-slot:head(withHolding)>
          <span v-if="!isHideRestraintColumnInInvoicesEnabled && !isBlList && !isAvoirDetailsButton && !isAvoirList" >Retenue (TND)</span>
        </template>

        <template v-slot:head(company)>
          <span v-if="!isAvoirDetailsButton && !isAvoirList && !isParaOnly" >Type </span>
        </template>

          <template v-slot:head(claim)>
                <span v-if="isBlList" >Réclamation</span>
          </template>
          
          <template v-slot:cell(claim)="{item}">
            <i v-if="isBlList" class="mdi mdi-comment-text-multiple-outline font-size-20 font-weight-bold text-danger ml-2 " style="cursor:pointer" @click="addClaim(item)"></i>
          </template> 

          <template v-slot:cell(company)="{item,value}">
            <div v-if="!isParaOnly">
              <b-badge class="font-weight-bold" v-if="isBlList" :variant="item.blType === 'URGENT' ? 'danger' : 'light'">{{item.blType}}</b-badge>
              <b-badge v-else-if="item.company" href="#" :variant="value === 'PARA' ? 'primary' : 'success'" class="font-size-12 font-weight-bold">
                {{item.company}} 
              </b-badge>
            </div>
          </template> 
        

        <template v-slot:cell(actions)="{item}"> 
        <!-- <router-link :to="{ path: '/orders/order', query: { id: item.id }}"> -->
        <div class="d-flex align-items-center ">
          <!-- Omnipharm: same look as the "Règlements" button next to it -->
          <b-button v-if="isShowRelatedBL_BR_Enabled && isInvoicesListNewUxEnabled && !isBlList && !isAvoirDetailsButton && !isAvoirList" class="mr-2 mr-xl-3 text-nowrap" title="Voir le détail de la facture" size="sm" variant="outline-dark" @click="openRelatedBLandBR(item)">
            <i class="bx bx-detail font-size-16 align-middle" aria-hidden="true"></i>
            <span class="d-none d-xl-inline font-weight-bold align-middle ml-1">{{ $t("invoicesMenu.OpenRelatedBLandBR.button") }}</span>
          </b-button>
          <b-button v-else-if="isShowRelatedBL_BR_Enabled && !isBlList && !isAvoirDetailsButton && !isAvoirList" class="mr-2 mr-xl-3 " title="Détails facture"  size="sm"   variant="light" @click="openRelatedBLandBR(item)">
                <i class="fas fa-info-circle d-xl-none font-size-16 align-middle " ></i> 
                <span class="d-none font-weight-bold d-xl-inline text-primary font-size-14"  style="position: relative; top: 2px;" > {{ $t("invoicesMenu.OpenRelatedBLandBR.button") }} </span>
          </b-button>           

          <!-- Omnipharm: no top margin so Télécharger lines up with the other buttons; other instances keep mt-3 -->
          <div v-if="isElectronicInvoiceEnable && isInvoiceList" :class="isInvoicesListNewUxEnabled ? '' : 'mt-3'">
            <b-dropdown
              id="invoice-type-dropdown"
              dropleft 
              variant="outline-secondary"
              text="Télécharger"
              class="w-100"
              size="sm"
            >
              <b-dropdown-item
                v-for="invoice in getInvoiceTypes(item.company)"
                :key="invoice.code"
                @click="downloadInvoice(item, invoice.code)"
              >
                {{ invoice.label }}
              </b-dropdown-item>
            </b-dropdown>

          </div>

          <b-button v-else  title="Ouvrir"  size="sm"   variant="outline-secondary" @click="downloadInvoice(item)" :disabled="isDownloadInProgress">
                <b-spinner v-if="isDownloadInProgress" small class="mr-0 mr-xl-2" ></b-spinner>
                <i v-if="!isDownloadInProgress" class="far fa-file-alt  font-size-16 align-middle mr-0 mr-xl-2"></i>
                <span class="d-none font-weight-bold d-xl-inline " style="position: relative; top: 2px;"> {{isAvoirDetailsButton == true ? $t("avoir.OpenButton") : "Télécharger" }} </span>
          </b-button> 
        </div>
        <!-- </router-link> -->

      </template>

        </b-table>
        <span v-if="!isTableLoading && ((invoicesList && !invoicesList.length ) && (consigneList && !consigneList.length))" class="d-flex justify-content-center m-4 text-danger" >{{$t("invoicesMenu.list.empty")}}</span>
    </div>

    <!-- Pagination -->
    <div v-if="!this.isBlList && !this.isConsigneList" class="row pt-3 mb-sm-4">
        <div class="col-sm-8">
            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                <b-form-select @input="getInvoices()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{$t('pagination.lines')}}</span></div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getInvoices()" :disabled="isTableLoading"></b-pagination>
                </ul>
            </div>
        </div>
    </div> 
    <!-- Fin Pagination  -->

    <!-- Front Pagination -->
    <div v-else-if="!this.isConsigneList" class="row pt-3 mb-sm-4">
        <div class="col-sm-8">
            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                <b-form-select @input="getSlicedInvoices()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{$t('pagination.lines')}}</span></div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getSlicedInvoices()" :disabled="isTableLoading"></b-pagination>
                </ul>
            </div>
        </div>
    </div> 
    <!-- Fin Pagination  -->
     
    <component :is="avoirModalZero" v-if="templateAddNewAvoirModalNumber == 0 && showAddNewAvoirModal" :onClose="onCloseAddNewAvoirModal" :showAddNewAvoirModal="showAddNewAvoirModal"  :propsAvoirId="this.avoirDetails.avoirId"
      :title="isNew ? $t('avoir.newAvoir.modal.titleNewAvoir') : $t('avoir.newAvoir.modal.statusAvoir')" :isNew="isNew"></component>
    
    <component :is="avoirModalOne" v-if="templateAddNewAvoirModalNumber == 1 && showAddNewAvoirModal" 
      :onClose="onCloseAddNewAvoirModal" 
      :showAddNewAvoirModal="showAddNewAvoirModal"  :propsAvoirId="this.avoirDetails.avoirId"
      :title="isNew ? $t('avoir.newAvoir.modal.titleNewAvoir') : $t('avoir.newAvoir.modal.statusAvoir')" 
      :isNew="isNew"
      ref="itemModalComponent"
      :isSearchAvoirItemWithBarcodeScannerEnabled="isSearchAvoirItemWithBarcodeScannerEnabled"
      
      
      ></component>

  <b-modal
    v-model="showBLandBRModal"
    :title="'CLIENT:  '+ (selectedInvoice && selectedInvoice.customer ?selectedInvoice.customer : '') +'  - FACTURE:   ' + (selectedInvoice && selectedInvoice.number ? selectedInvoice.number : '')" 
    title-class="text-primary"
    title-tag="h4"
    header-close-variant="danger"
    size="lg"
    @hide="onCloseShowBLandBRModal"      
    hide-header
    >

  <b-tabs v-model="activeTabIndex" class="mb-3" 
  fill 
          nav-class="nav-tabs-custom" 
          content-class="p-0 text-muted" 
          active-nav-item-class="font-weight-bold text-uppercase " >

    <!-- TAB 1: BL -->
    <b-tab  active lazy>
      <template v-slot:title>
        <span class="d-inline-block d-sm-none"> BL</span>
        <span class="d-none d-sm-inline-block font-size-14 text-uppercase">Bons de Livraison <span class="font-size-12">({{ (selectedInvoice && selectedInvoice.number ? selectedInvoice.number : '')   }})</span></span>
      </template>
      <div class="mt-4" style="min-height:40em;">
        <b-table
          :busy="isTableRelatedBLLoading"
          :striped="true"
          :small="false"
          :hover="true"
          :items="BLList"
          :fields="relatedBLTableFields"
          :per-page="pagemodelBLList.perPage"
          class="table"
        >
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
          </template>

          <template v-slot:cell(actions)="{ item }">
            <b-button
              title="Ouvrir"
              size="sm"
              variant="outline-secondary"
              @click="downloadrelatedBLByDocNumber(item.number, item.type, item.company)"
              :disabled="isDownloadInProgress"
            >
              <b-spinner v-if="isDownloadInProgress" small class="mr-2"></b-spinner>
              <i v-else class="far fa-file-alt font-size-16 align-middle mr-xl-2"></i>
              <span class="d-none font-weight-bold d-xl-inline">Télécharger</span>
            </b-button>
          </template>
        </b-table>
        <span v-if="!isTableRelatedBLLoading && BLList && !BLList.length" class="d-flex justify-content-center m-4 text-danger">{{ $t("invoicesMenu.list.empty") }}</span>

        <!-- Pagination -->
        <div  class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getRelatedBL()"  v-model="pagemodelBLList.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodelBLList.totalRows}} {{$t('pagination.lines')}}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelBLList.currentPage" :per-page="pagemodelBLList.pageSize" :total-rows="pagemodelBLList.totalRows" @input="getRelatedBL()" :disabled="isTableRelatedBLLoading"></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
      </div>
    </b-tab>

    <!-- TAB 2: BR -->
    <b-tab  lazy>
      <template v-slot:title>
        <span class="d-inline-block d-sm-none"> BR</span>
        <span class="d-none d-sm-inline-block font-size-14 text-uppercase">Bons de Retour <span class="font-size-12">({{ (selectedInvoice && selectedInvoice.number ? selectedInvoice.number : '')   }})</span></span>
      </template>
      <div class="mt-4" style="min-height:40em;">
        <b-table
          :busy="isTableRelatedBRLoading"
          :striped="true"
          :small="false"
          :hover="true"
          :items="BRList"
          :fields="relatedBLTableFields"
          :per-page="pagemodelBRList.perPage"
          class="table"
        >
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
          </template>

          <template v-slot:cell(actions)="{ item }">
            <b-button
              title="Ouvrir"
              size="sm"
              variant="outline-secondary"
              @click="downloadrelatedBLByDocNumber(item.number, item.type, item.company)"
              :disabled="isDownloadInProgress"
            >
              <b-spinner v-if="isDownloadInProgress" small class="mr-2"></b-spinner>
              <i v-else class="far fa-file-alt font-size-16 align-middle mr-xl-2"></i>
              <span class="d-none font-weight-bold d-xl-inline">Télécharger</span>
            </b-button>
          </template>
        </b-table>
        <span v-if="!isTableRelatedBRLoading && BRList && !BRList.length" class="d-flex justify-content-center m-4 text-danger">{{ $t("invoicesMenu.list.empty") }}</span>

        <!-- Pagination -->
        <div  class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getRelatedBR()"  v-model="pagemodelBRList.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodelBRList.totalRows}} {{$t('pagination.lines')}}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelBRList.currentPage" :per-page="pagemodelBRList.pageSize" :total-rows="pagemodelBRList.totalRows" @input="getRelatedBR()" :disabled="isTableRelatedBRLoading"></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
      </div>
    </b-tab>
  </b-tabs>
  <template #modal-footer="{ hide }">
    <b-button variant="secondary" @click="onCloseShowBLandBRModal()">Fermer
    </b-button>
  </template>
</b-modal> 

<b-modal
  v-model="showReglementModal"
  size="lg"
  centered
  hide-header
  body-class="p-0"
  @hide="onCloseShowReglementModal"
>
  <div v-if="selectedInvoice" class="rg">
    <header class="rg-head">
      <div>
        <span class="rg-eyebrow">Règlements de la facture</span>
        <h4 class="rg-title">{{ selectedInvoice.number || '-' }}</h4>
        <span class="rg-meta">
          <i class="bx bx-calendar" aria-hidden="true"></i> {{ selectedInvoice.date || '-' }}
          <template v-if="selectedInvoice.customer"><span class="rg-dot">·</span>{{ selectedInvoice.customer }}</template>
        </span>
      </div>
      <span v-if="reglementSummary.state" class="rg-status" :class="'rg-tone--' + reglementSummary.state">
        <i class="bx" :class="reglementSummary.state === 'paid' ? 'bx-check-circle' : 'bx-time-five'" aria-hidden="true"></i>
        {{ reglementSummary.state === 'paid' ? 'Soldée' : 'Reste à payer' }}
      </span>
    </header>

    <section class="rg-summary" :class="reglementSummary.state ? 'rg-tone--' + reglementSummary.state : ''">
      <div class="rg-figures">
        <div class="rg-figure">
          <span class="rg-figure__label">Montant TTC</span>
          <span class="rg-figure__value">{{ reglementSummary.total }}</span>
        </div>
        <div v-if="reglementSummary.paid !== null" class="rg-figure">
          <span class="rg-figure__label">Déjà réglé</span>
          <span class="rg-figure__value">{{ reglementSummary.paid }}</span>
        </div>
        <div v-if="reglementSummary.remaining !== null" class="rg-figure rg-figure--remaining">
          <span class="rg-figure__label">Reste à payer</span>
          <span class="rg-figure__value">{{ reglementSummary.remaining }}</span>
        </div>
      </div>
      <template v-if="reglementSummary.percent !== null">
        <div class="rg-progress" role="progressbar" :aria-valuenow="Math.round(reglementSummary.percent)" aria-valuemin="0" aria-valuemax="100">
          <span class="rg-progress__bar" :style="{ width: reglementSummary.percent + '%' }"></span>
        </div>
        <span class="rg-progress__caption">Réglée à {{ reglementSummary.percentLabel }}</span>
      </template>
    </section>

    <section class="rg-body">
      <div class="rg-body__head">
        <h5 class="rg-body__title">Historique des règlements</h5>
        <span v-if="!isTableRelatedReglementLoading && pagemodelReglementList.totalRows" class="rg-count">
          {{ pagemodelReglementList.totalRows }} {{ pagemodelReglementList.totalRows > 1 ? 'opérations' : 'opération' }}
        </span>
      </div>

      <div v-if="isTableRelatedReglementLoading" class="rg-loading">
        <b-spinner small variant="secondary" class="mr-2"></b-spinner> Chargement des règlements…
      </div>

      <div v-else-if="!reglementRows.length" class="rg-empty">
        <i class="bx bx-receipt" aria-hidden="true"></i>
        <strong>Aucun règlement enregistré</strong>
        <span>Aucun règlement n'est encore rattaché à cette facture.</span>
      </div>

      <ol v-else class="rg-timeline">
        <li v-for="row in reglementRows" :key="row.position" class="rg-item" :class="'rg-kind--' + row.kind">
          <span class="rg-item__icon" aria-hidden="true"><i class="bx" :class="row.icon"></i></span>
          <div class="rg-item__main">
            <span class="rg-item__label" :title="row.rawType">{{ row.label }}</span>
            <span v-if="row.meta" class="rg-item__meta">{{ row.meta }}</span>
            <span v-if="row.due" class="rg-due" :class="'rg-due--' + row.due.state">
              <i class="bx" :class="row.due.state === 'upcoming' ? 'bx-time-five' : 'bx-calendar-check'" aria-hidden="true"></i>
              {{ row.due.label }}
            </span>
          </div>
          <div class="rg-item__side">
            <span class="rg-item__amount">{{ row.amount }}</span>
            <span v-if="row.mntReg" class="rg-item__meta">sur un règlement de {{ row.mntReg }}</span>
          </div>
        </li>
      </ol>

      <div v-if="pagemodelReglementList.totalRows > pagemodelReglementList.perPage" class="rg-pagination">
        <b-pagination v-model="pagemodelReglementList.currentPage" :per-page="pagemodelReglementList.perPage" :total-rows="pagemodelReglementList.totalRows" @input="getRelatedReglement()" :disabled="isTableRelatedReglementLoading" size="sm" class="pagination-rounded mb-0"></b-pagination>
      </div>
    </section>
  </div>

  <template #modal-footer="{ hide }">
    <b-button variant="outline-dark" @click="onCloseShowReglementModal(); hide()">Fermer</b-button>
  </template>
</b-modal>
</div>
</template>

<style scoped>
.inv-settled { display: inline-flex; align-items: center; gap: .3rem; padding: .3rem .7rem; border-radius: 999px; font-size: 13px; font-weight: 700; line-height: 1.2; color: #146c43; background: #e3f4ec; white-space: nowrap; }
.inv-settled .bx { font-size: 16px; }
.inv-ack-cell { display: inline-flex; flex-direction: column; align-items: flex-end; gap: .15rem; line-height: 1.25; }
.inv-ack__name { font-size: 13px; font-weight: 600; color: #1f2937; white-space: nowrap; }
.inv-ack__when { display: inline-flex; gap: .45rem; font-size: 12px; color: #667085; white-space: nowrap; font-variant-numeric: tabular-nums; }
.inv-due { display: inline-flex; align-items: center; gap: .3rem; padding: .3rem .7rem; border-radius: 999px; font-size: 13px; font-weight: 700; line-height: 1.2; white-space: nowrap; }
.inv-due .bx { font-size: 16px; }
.inv-due--ok { color: #344054; background: #f2f4f7; }
.inv-due--soon { color: #c2410c; background: #fff1e6; }
.inv-due--overdue { color: #b42318; background: #fdecea; }

.rg { --rg-ink: #1f2937; --rg-muted: #667085; --rg-line: #e4e7ec; --rg-soft: #f8f9fb; color: var(--rg-ink); }
.rg-tone--paid { --rg-fg: #146c43; --rg-bg: #e3f4ec; --rg-bar: #1a7f4f; }
.rg-tone--due { --rg-fg: #c2410c; --rg-bg: #fff1e6; --rg-bar: #ea580c; }

.rg-head { display: flex; flex-wrap: wrap; align-items: flex-start; justify-content: space-between; gap: .75rem 1rem; padding: 1.25rem 1.5rem 1rem; border-bottom: 1px solid var(--rg-line); }
.rg-eyebrow { display: block; font-size: 11px; font-weight: 600; letter-spacing: .06em; text-transform: uppercase; color: var(--rg-muted); }
.rg-title { margin: .15rem 0 .25rem; font-size: 1.3rem; font-weight: 700; color: var(--rg-ink); }
.rg-meta { font-size: 13px; color: var(--rg-muted); }
.rg-dot { margin: 0 .4rem; }
.rg-status { display: inline-flex; align-items: center; gap: .35rem; padding: .4rem .8rem; border-radius: 999px; font-size: 13px; font-weight: 700; color: var(--rg-fg); background: var(--rg-bg); white-space: nowrap; }
.rg-status .bx { font-size: 17px; }

.rg-summary { padding: 1rem 1.5rem 1.1rem; background: var(--rg-soft); border-bottom: 1px solid var(--rg-line); }
.rg-figures { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: .75rem 1.5rem; }
.rg-figure__label { display: block; font-size: 12px; color: var(--rg-muted); }
.rg-figure__value { display: block; font-size: 1.05rem; font-weight: 700; font-variant-numeric: tabular-nums; white-space: nowrap; }
.rg-figure--remaining .rg-figure__value { color: var(--rg-fg, var(--rg-ink)); }
.rg-progress { margin-top: .9rem; height: 8px; border-radius: 999px; background: #e4e7ec; overflow: hidden; }
.rg-progress__bar { display: block; height: 100%; border-radius: inherit; background: var(--rg-bar, #98a2b3); transition: width .3s ease; }
.rg-progress__caption { display: block; margin-top: .35rem; font-size: 12px; color: var(--rg-muted); }

.rg-body { padding: 1rem 1.5rem 1.25rem; }
.rg-body__head { display: flex; align-items: baseline; justify-content: space-between; gap: 1rem; margin-bottom: .35rem; }
.rg-body__title { margin: 0; font-size: 14px; font-weight: 700; }
.rg-count { font-size: 12px; color: var(--rg-muted); }
.rg-loading { display: flex; align-items: center; padding: 1.5rem 0; color: var(--rg-muted); }
.rg-empty { display: flex; flex-direction: column; align-items: center; gap: .2rem; padding: 1.75rem 0 1.25rem; text-align: center; color: var(--rg-muted); }
.rg-empty .bx { font-size: 30px; color: #98a2b3; }
.rg-empty strong { color: var(--rg-ink); }

.rg-timeline { list-style: none; margin: 0; padding: 0; }
.rg-item { display: grid; grid-template-columns: 36px 1fr auto; gap: .2rem .85rem; align-items: start; padding: .75rem 0; }
.rg-item + .rg-item { border-top: 1px dashed var(--rg-line); }
.rg-item__icon { display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 50%; background: #eef1f6; color: #344054; font-size: 18px; }
.rg-item__label { display: block; font-size: 14px; font-weight: 700; }
.rg-item__meta { display: block; font-size: 12.5px; color: var(--rg-muted); font-variant-numeric: tabular-nums; }
.rg-item__side { text-align: right; }
.rg-item__amount { padding-top: .1rem; font-size: 14px; font-weight: 700; font-variant-numeric: tabular-nums; white-space: nowrap; }
.rg-due { display: inline-flex; align-items: center; gap: .3rem; margin-top: .3rem; font-size: 12px; font-weight: 600; }
.rg-due--upcoming { color: #c2410c; }
.rg-due--past { color: var(--rg-muted); font-weight: 500; }
.rg-kind--adjustment .rg-item__icon { background: transparent; border: 1px dashed #d0d5dd; color: #98a2b3; }
.rg-kind--adjustment .rg-item__label,
.rg-kind--adjustment .rg-item__amount { color: var(--rg-muted); font-weight: 600; }
.rg-pagination { display: flex; justify-content: flex-end; margin-top: .75rem; }

@media (max-width: 575.98px) {
  .rg-head, .rg-summary, .rg-body { padding-left: 1rem; padding-right: 1rem; }
  .rg-item { grid-template-columns: 32px 1fr; }
  .rg-item__icon { width: 32px; height: 32px; font-size: 16px; }
  .rg-item__side { grid-column: 2; }
}
</style>
